import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignUpForm from "../../components/auth/SignUpForm";

export default function SignUp() {
  return (
    <>
      <PageMeta
        title="Create Your Account - Neo"
        description="Create your Neo console account to track store performance, monitor sales and orders, and access real-time eCommerce analytics."
      />
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}
